import assertNever from 'assert-never';

import { CloudGatewayManagedDevice } from '@shure/cloud/shared/models/devices';
import { mapDeviceModelFromSysApi } from '@shure/shared/angular/data-access/system-api/mappers';
import { DeviceStatus } from '@shure/shared/angular/data-access/system-api/models';

import {
	CloudGatewayManagedDeviceFragment,
	CloudGatewayManagedPartialDeviceFragment,
	CloudGatewayManagedPartialDeviceStatus
} from '../graphql/generated/cloud-sys-api';

export function mapCloudGatewayManagedDeviceFromSysApi(
	device: CloudGatewayManagedDeviceFragment | CloudGatewayManagedPartialDeviceFragment
): CloudGatewayManagedDevice {
	if (device.__typename === 'Device') {
		return {
			isDeviceNode: true,
			nodeId: device.id,
			hardwareId: device.hardwareId
		};
	}

	return {
		isDeviceNode: false,
		hardwareId: device.hardwareId,
		model: mapDeviceModelFromSysApi(device.model),
		name: device.name,
		status: mapPartialDeviceStatusToDeviceStatus(device.partialDeviceStatus),
		ipAddress: device.ipAddress ?? '',
		macAddress: device.macAddress ?? '',
		serialNumber: device.serialNumber,
		roomName: device.roomName ?? ''
	};
}

function mapPartialDeviceStatusToDeviceStatus(
	partialDeviceStatus: CloudGatewayManagedPartialDeviceStatus
): DeviceStatus {
	switch (partialDeviceStatus) {
		case CloudGatewayManagedPartialDeviceStatus.Pending:
			return DeviceStatus.Discovered;
		case CloudGatewayManagedPartialDeviceStatus.Unavailable:
			return DeviceStatus.Offline;
		case CloudGatewayManagedPartialDeviceStatus.Error:
			return DeviceStatus.Error;
		default:
			assertNever(partialDeviceStatus);
	}
}
